module.exports = __webpack_public_path__ + "static/media/29DUNON10.29728a31.jpg";